import { jsx as _jsx } from "react/jsx-runtime";
import { Select, useLocalizeMessage } from 'libs.nucleus';
import { PIOversightStatus } from '../../../types/pi_oversight.types';
const TableCustomHeader = ({ piOversightStatus, onSelectPIOversightStatus, }) => {
    const translate = useLocalizeMessage();
    const piOversightStatusOptions = [
        { label: translate('label.pi_oversight.status.overdue'), value: PIOversightStatus.OVERDUE },
        { label: translate('label.pi_oversight.status.review_required'), value: PIOversightStatus.REVIEW_REQUIRED },
        { label: translate('label.pi_oversight.status.current'), value: PIOversightStatus.CURRENT },
    ];
    return (_jsx(Select, { options: piOversightStatusOptions, onChange: onSelectPIOversightStatus, label: translate('label.pi_oversight.pi_review_status'), value: piOversightStatus, width: 'sm', dataTestId: 'pi-oversight-status-dropdown' }, 'piOversightStatus'));
};
export default TableCustomHeader;
